import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × TESLA: Kinetic intelligence
// Electric lines, metallic gradient, energy arcs
export function VasarelyTeslaMode({ brand }: ModeRendererProps) {
  const teslaRed = "#E82127";

  return (
    <g>
      {/* Metallic gradient background */}
      <defs>
        <linearGradient id="tesla-metallic" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#1A1A1A" />
          <stop offset="50%" stopColor="#2C2C2C" />
          <stop offset="100%" stopColor="#1A1A1A" />
        </linearGradient>
        <radialGradient id="tesla-energy">
          <stop offset="0%" stopColor={teslaRed} stopOpacity="0.6" />
          <stop offset="100%" stopColor={teslaRed} stopOpacity="0" />
        </radialGradient>
      </defs>

      <rect x="0" y="0" width="794" height="1123" fill="url(#tesla-metallic)" />

      <g transform="translate(397 540)">
        {/* Electric lines (circuit flow) */}
        {Array.from({ length: 32 }).map((_, i) => {
          const angle = (i * Math.PI * 2) / 32;
          const energy = Math.random() * 40;
          
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * (220 + energy)}
              y2={Math.sin(angle) * (220 + energy)}
              stroke={teslaRed}
              strokeWidth="2"
              opacity={0.4 + Math.random() * 0.2}
            />
          );
        })}

        {/* Energy arcs (electromagnetic) */}
        {[0, 60, 120, 180, 240, 300].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 180;
          const nextRad = ((angle + 60) * Math.PI) / 180;
          
          return (
            <path
              key={angle}
              d={`M ${Math.cos(rad) * r} ${Math.sin(rad) * r} Q 0 0 ${Math.cos(nextRad) * r} ${Math.sin(nextRad) * r}`}
              fill="none"
              stroke={teslaRed}
              strokeWidth="3"
              opacity="0.5"
            />
          );
        })}

        {/* Kinetic grid */}
        {Array.from({ length: 14 }).map((_, i) =>
          Array.from({ length: 18 }).map((_, j) => {
            const x = (i - 6.5) * 44;
            const y = (j - 8.5) * 42;
            const motion = Math.sin(i * 0.5 + j * 0.3) * 8;
            
            return (
              <rect
                key={`${i}-${j}`}
                x={x - 18 + motion}
                y={y - 18}
                width="36"
                height="36"
                fill="none"
                stroke="#666"
                strokeWidth="1"
                opacity="0.2"
              />
            );
          })
        )}

        {/* Metallic accent circles */}
        {Array.from({ length: 14 }).map((_, i) => {
          const r = 50 + i * 16;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke="#888"
              strokeWidth="1"
              opacity={0.3 - i * 0.018}
            />
          );
        })}

        {/* Intelligence nodes (autopilot sensors) */}
        {[0, 45, 90, 135, 180, 225, 270, 315].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 200;
          
          return (
            <g key={angle}>
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="30"
                fill="url(#tesla-energy)"
              />
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="8"
                fill={teslaRed}
                opacity="0.8"
              />
              <circle
                cx={Math.cos(rad) * r}
                cy={Math.sin(rad) * r}
                r="12"
                fill="none"
                stroke={teslaRed}
                strokeWidth="2"
                opacity="0.6"
              />
            </g>
          );
        })}

        {/* Central power core */}
        <circle cx="0" cy="0" r="70" fill="url(#tesla-energy)" />
        <circle cx="0" cy="0" r="40" fill={teslaRed} opacity="0.4" />
        <circle cx="0" cy="0" r="40" fill="none" stroke={teslaRed} strokeWidth="3" opacity="0.8" />
        
        {/* T logo suggestion */}
        <rect x="-3" y="-30" width="6" height="60" fill={brand.white} opacity="0.9" />
        <rect x="-25" y="-30" width="50" height="8" fill={brand.white} opacity="0.9" />
      </g>

      {/* Tesla text */}
      <text x="397" y="1030" textAnchor="middle" fontFamily="sans-serif" fontWeight="700" fontSize="12" fill={teslaRed} opacity="0.8">
        INTELLIGENCE CINÉTIQUE
      </text>
    </g>
  );
}
